import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const CircleAddIcon: React.FC<NormalIconProps> = (props) => (
	<svg className={props.className ? props.className : 'fill--midnight-green'} width="26.465" height="26.465" viewBox="0 0 26.465 26.465">
		<g id="Group_3861" data-name="Group 3861">
			<g id="Group_3860" data-name="Group 3860">
				<path
					id="Path_5110"
					data-name="Path 5110"
					d="M13.232,0A13.232,13.232,0,1,0,26.465,13.232,13.247,13.247,0,0,0,13.232,0Zm0,24.415A11.183,11.183,0,1,1,24.415,13.232,11.2,11.2,0,0,1,13.232,24.415Z"
				/>
			</g>
		</g>
		<g id="Group_3863" data-name="Group 3863" transform="translate(7.083 6.99)">
			<g id="Group_3862" data-name="Group 3862">
				<path
					id="Path_5111"
					data-name="Path 5111"
					d="M148.3,140.363h-4.1v-4.1a1.025,1.025,0,1,0-2.05,0v4.1h-4.1a1.025,1.025,0,0,0,0,2.05h4.1v4.1a1.025,1.025,0,1,0,2.05,0v-4.1h4.1a1.025,1.025,0,0,0,0-2.05Z"
					transform="translate(-137.022 -135.238)"
				/>
			</g>
		</g>
	</svg>
);
